const DISTANCE_BETWEEN_EDGES = 1;

/**
 * Abstract implementation for unit-testing without hardcoded constant, since current constant value 1
 * is easy to omit without breaking the abstraction, making our function work until it remains 1
 * but wrong in general.
 */
const getEdgeShiftAbstract =
  (distanceBetweenEdges: number) =>
  (numberOfEdge: number, totalEdges: number): number =>
    // set sign by oddity of numberOfEdge + totalEdges so that we start positive for even groups
    // and make second (->first non-zero) shift positive for odd groups
    distanceBetweenEdges *
    (numberOfEdge === 0 || (numberOfEdge + totalEdges) % 2 === 0 ? 1 : -1) *
    (totalEdges % 2 === 0
      ? Math.floor(numberOfEdge / 2) + 0.5
      : Math.ceil(numberOfEdge / 2));

export const getEdgeShift = getEdgeShiftAbstract(DISTANCE_BETWEEN_EDGES);

export const testable = {
  getEdgeShiftAbstract,
};
